import React from 'react';

import { TextField } from '@material-ui/core';

import styles from '../readyForCarriageCheck.module.css';
import commonStyles from '../../common/common.module.css';

interface InfoToWhProps {
  infoToWhs: string;
  disabled: boolean;
  handleChange: (event: any) => void;
  handleSetInfoToWh: () => void;
};

const TEXT_FIELD_PADDINGS: string = '10px 6px 10px 10px';
const TEXT_FIELD_WIDTH: string = '100%';
const SELECT_FONT_SIZE: string = '13px';

const infoToWh = (props: InfoToWhProps) => {

  return (
    <div className= { `${ commonStyles.wrapper }` }>
      <h3 className={ `${ commonStyles.header }` }>
        Info to WH
      </h3>
      <div className={ styles.notesWrapper }>
        <TextField 
          multiline
          value={ props.infoToWhs }
          variant="outlined"
          onChange={ props.handleChange }
          onBlur={ props.handleSetInfoToWh }
          disabled={ props.disabled }
          InputProps={{ style: { padding: TEXT_FIELD_PADDINGS, width: TEXT_FIELD_WIDTH, fontSize: SELECT_FONT_SIZE } }} 
          fullWidth
        />
      </div>
    </div>
  );
}

export default infoToWh;